var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1659 1.28268C12.5605 0.678213 13.446 0.678214 13.8406 1.28268L23.2547 15.7034C23.689 16.3685 23.2117 17.25 22.4174 17.25H3.58915C2.79482 17.25 2.31757 16.3685 2.75179 15.7034L12.1659 1.28268Z",
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8739 6H12.0281V12.1274H13.8739V6ZM12.951 14.78C13.5753 14.78 14.03 14.3599 14.03 13.8318C14.03 13.2977 13.5753 12.8836 12.951 12.8836C12.3335 12.8836 11.8721 13.2977 11.8721 13.8318C11.8721 14.3599 12.3335 14.78 12.951 14.78Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.7d2b15cb1dca24dfcbb28da0899ff718.svg";
export { ForwardRef as ReactComponent };